import { Entry } from 'contentful'
import { GenericContentBlock } from 'types/contentful/genericContentBlock'
import Link from '@components/common/NoPrefetchLink'

interface INavLinks {
  navList: Entry<GenericContentBlock>[]
}

export function NavLinks({ navList }: INavLinks) {
  return (
    <div className="justify-center hidden w-full pb-8 bg-core-grey-10 md:flex pt-9">
      <ul className="flex">
        {navList?.map((item, index) => (
          <li key={index} className="mx-5">
            <Link href={item?.fields?.ctaLink}>
              <span className="text-lg font-bold tracking-wide uppercase cursor-pointer text-acai hover:text-pitaya">
                {item?.fields?.ctaLabel}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
